import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const deleteNotification = async (domain: string, flowId: number, notificationId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}/messages-templates/${notificationId}`,
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        },
        domain
    });
}